function Statistics252() {
  return (
    <div>
      <p>The current version of DISGENET (v25.2) contains:</p>
      <ul>
        <li className="bullet-item">
          <b>2,007,239</b> gene-disease associations (GDAs), between <b>30,195</b> genes and <b>38,126</b>{' '}
          diseases and phenotypes
          <ul>
            <li className="bullet-item">
              <b>6,230,277</b> evidences for GDAs, supported by <b>1,653,736</b> publications
            </li>
            <li className="bullet-item">
              <b>350,000</b> GDAs involving <b>13,000</b> diseases that have been detected in animal models
            </li>
            <li className="bullet-item">
              <b>255,376</b> GDAs are annotated with <b>14,054</b> chemicals (relating <b>12,053</b> genes and{' '}
              <b>9,598</b> diseases)
            </li>
          </ul>
        </li>
        <li className="bullet-item">
          <b>4,446,773</b> variant-disease associations (VDAs), between <b>1,437,920</b> variants and{' '}
          <b>19,076</b> diseases and phenotypes.
          <ul>
            <li className="bullet-item">
              <b>6,949,543</b> evidences for the VDAs, supported by <b>189,094</b> publications
            </li>
            <li className="bullet-item">
              <b>11,844</b> VDAs are annotated with <b>1,532</b> chemicals (relating <b>4,061</b> variants and{' '}
              <b>1,823</b> diseases)
            </li>
          </ul>
        </li>
        <li className="bullet-item">
          <b>28,134,468</b> disease-disease associations.
        </li>
        <li className="bullet-item">
          This release provides annotations for <strong>14,073</strong> chemicals and drugs associated with
          GDAs and VDAs.
        </li>
        <li className="bullet-item">
          In total, DISGENET contains a corpus of <b>1,658,844</b> publications that support the
          genotype-phenotype associations.
        </li>
        <li className="bullet-item">
          There are <b>13,216,184</b> individual pieces of evidence in the database supporting{' '}
          <b>6,380,188</b> genotype-phenotype associations (GDAs & VDAs)
        </li>
      </ul>
    </div>
  );
}

export default Statistics252;
